import api from "@/apis/maintenance-api.js";
import validToken from "@/mixins/valid-token.js";
export default {
  mixins: [validToken],
  data() {
    return {
      showPopup: false,
      popupTitle: "",
      popupList: [],
      category: -1,
    };
  },
  methods: {
    // 检查机油- 汽车子分类
    async checkEngineOil() {
      this.checkEngineList();
    },
    /**
     * 检查变速箱油车型备注（同时缓存详情）
     * @returns
     */
    async checkTransmissionOil() {
      this.category = 2;
      await this.fetchValidToken();
      if (!this.token) return;
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        parts_type: 2,
        vehicle_ids: this.dynamic_vehicle_ids,
        token: this.token,
        scheme_id,
      };
      this.$loading.show("加载中...");
      try {
        // 优先取缓存数据
        let cacheDetail = null;
        const gearboxOilCacheString = sessionStorage.getItem("gearboxOilCache");
        if (
          gearboxOilCacheString &&
          JSON.parse(gearboxOilCacheString).key ===
            this.dynamic_vehicle_ids_query
        ) {
          cacheDetail = JSON.parse(gearboxOilCacheString).value;
        }
        const res = cacheDetail || (await api.getModelDetail(params));
        if (res.code === 0) {
          // 以key和内部属性为dynamic_vehicle_ids的形式标记菜单和车型，任意时刻仅会存储一种车型的数据
          sessionStorage.setItem(
            "gearboxOilCache",
            JSON.stringify({
              key: this.dynamic_vehicle_ids_query,
              value: res,
            })
          );
          if (res.data.datum_list && res.data.datum_list.length > 1) {
            res.data.datum_list.forEach((i) => (i.text = i.choices[0].value));
            let tempChoices = res.data.datum_list.map((i) => {
              return { choices: i.choices, key: i.key };
            });
            tempChoices.forEach((i) => {
              i.text = i.choices.reduce(
                (res, cur) =>
                  `${res}${res ? "<br>" : ""}${
                    cur.name
                  }: <span style="color:#333">${cur.value}</span>`,
                ""
              );
              i.multiple = i.text.length > 8 ? true : false;
            });
            this.popupTitle = "额外选项";
            this.popupList = tempChoices;
            this.showPopup = true;
            // 没有直接跳转
          } else {
            const query_object = {
              scheme_id: this.$route.query.scheme_id || "", //版本id
              menu_type: 2, //菜单标记
              vehicle_ids: this.dynamic_vehicle_ids_query, //车型id数组
              key: res.data.parts_list[0] ? res.data.parts_list[0].key : "", //额外选项的key
              internal_from: this.$route.query.internal_from, // 内部跳转来源标记
            };
            if (this.$route.name === "maintenance-detail") {
              this.dynamic_options = query_object;
              this.setNoteReadyAndSwitchTab();
              return;
            }
            this.$router.push({
              path: "/maintenance-detail",
              query: query_object,
            });
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    /**
     * 点击选项
     * @param {object} item
     */
    itemClickHandler(item) {
      console.log("点击选项", item, this.category);
      const { scheme_id } = this.$route.query;
      // 点击机油-发动机、点击机油-车型备注、点击箱油-额外选项、点击轮胎-额外选项
      // 机油-车型备注
      if (item.memo_val) {
        const query_object = {
          scheme_id,
          menu_type: 1,
          vehicle_id: item.vehicle_id,
          viscosity_type: item.type,
          internal_from: this.$route.query.internal_from,
        };
        if (this.$route.name === "maintenance-detail") {
          this.dynamic_options = query_object;
          this.setNoteReadyAndSwitchTab();
          return;
        }
        this.$router.push({
          path: "/maintenance-detail",
          query: query_object,
        });
        return;
      }
      // 机油-发动机
      if (item.engine_model) {
        let car = this.multipleEnginesCarsArr.find(
          (i) => i.engine_model === item.engine_model
        );
        if (car.memo_list.length > 0) {
          car.memo_list.forEach((i) => (i.text = i.memo_val));
          this.popupList = car.memo_list;
          this.popupTitle = "车型备注";
          this.showPopup = true;
        } else {
          const query_object = {
            scheme_id,
            menu_type: 1,
            vehicle_id: item.vehicle_id,
            viscosity_type: 1,
            internal_from: this.$route.query.internal_from,
          };
          if (this.$route.name === "maintenance-detail") {
            this.dynamic_options = query_object;
            this.setNoteReadyAndSwitchTab();
            return;
          }
          this.$router.push({
            path: "/maintenance-detail",
            // query: {
            //   menu: 1,
            //   levelId: item.vehicle_id,
            //   value: 1,
            //   scheme_id,
            //   internal_from: this.$route.query.internal_from,
            // },
            query: query_object,
          });
        }
        return;
      }
      // 点击变速箱油-额外选项
      if (this.category === 2) {
        const query_object = {
          scheme_id,
          menu_type: 2,
          key: item.key,
          vehicle_ids: this.dynamic_vehicle_ids_query, //车型id数组
          internal_from: this.$route.query.internal_from,
        };
        if (this.$route.name === "maintenance-detail") {
          this.dynamic_options = query_object;
          this.setNoteReadyAndSwitchTab();
          return;
        }
        this.$router.push({
          path: "/maintenance-detail",
          query: query_object,
        });
        return;
      }
      // 点击轮胎-额外选项
      if (this.category === 3) {
        const query_object = {
          scheme_id,
          menu_type: 3,
          key: item.key,
          vehicle_ids: this.dynamic_vehicle_ids_query,
          internal_from: this.$route.query.internal_from,
        };
        if (this.$route.name === "maintenance-detail") {
          this.dynamic_options = query_object;
          this.setNoteReadyAndSwitchTab();
          return;
        }
        this.$router.push({
          path: "/maintenance-detail",
          query: query_object,
        });
        return;
      }
      // 点击机油滤清器-车型备注
      if (this.category === 4) {
        const query_object = {
          scheme_id: this.$route.query.scheme_id,
          menu_type: 4,
          key: item.key,
          vehicle_ids: this.dynamic_vehicle_ids_query,
          internal_from: this.$route.query.internal_from,
        };
        if (this.$route.name === "maintenance-detail") {
          this.dynamic_options = query_object;
          this.setNoteReadyAndSwitchTab();
          return;
        }
        this.$router.push({
          path: "/detail",
          query: query_object,
        });
        return;
      }
    },
    /**
     * 检车车辆轮胎车型备注
     */
    async checkTireCategory() {
      this.category = 3;
      await this.fetchValidToken();
      if (!this.token) return;
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        parts_type: 3,
        vehicle_ids: this.dynamic_vehicle_ids,
        token: this.token,
        scheme_id,
      };
      this.$loading.show("加载中...");
      try {
        // 优先取缓存数据
        let cacheDetail = null;
        const tireCacheString = sessionStorage.getItem("tireCache");
        if (
          tireCacheString &&
          JSON.parse(tireCacheString).key === this.dynamic_vehicle_ids_query
        ) {
          cacheDetail = JSON.parse(tireCacheString).value;
        }
        let res = cacheDetail || (await api.getModelDetail(params));
        // res.data = mockcheckTireCategory;
        if (res.code === 0) {
          // 以key和内部属性为dynamic_vehicle_ids的形式标记菜单和车型，任意时刻仅会存储一种车型的数据
          sessionStorage.setItem(
            "tireCache",
            JSON.stringify({
              key: this.dynamic_vehicle_ids_query,
              value: res,
            })
          );
          if (res.data.parts_list.length > 1) {
            res.data.parts_list.forEach((i) => (i.text = i.choices[0].value));
            let tempChoices = res.data.parts_list.map((i) => {
              return { choices: i.choices, key: i.key };
            });
            tempChoices.forEach((i) => {
              i.text = i.choices.reduce(
                (res, cur) =>
                  `${res}${res ? "<br>" : ""}${
                    cur.name
                  }: <span style="color:#333">${cur.value}</span>`,
                ""
              );
              i.multiple = i.text.length > 8 ? true : false;
            });
            this.popupTitle = "额外选项";
            this.popupList = tempChoices;
            this.showPopup = true;
            // 没有直接跳转
          } else {
            const query_object = {
              scheme_id: this.$route.query.scheme_id || "",
              menu_type: 3,
              vehicle_ids: this.dynamic_vehicle_ids_query,
              key: res.data.parts_list[0] ? res.data.parts_list[0].key : "",
              internal_from: this.$route.query.internal_from,
            };
            if (this.$route.name === "maintenance-detail") {
              this.dynamic_options = query_object;
              this.setNoteReadyAndSwitchTab();
              return;
            }
            this.$router.push({
              path: "/maintenance-detail",
              query: query_object,
            });
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log(error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    /**
     * 检查机油滤清器车型备注
     */
    async checkOilFilterCategory() {
      this.category = 4;
      await this.fetchValidToken();
      if (!this.token) return;
      // let vehicle_ids = this.current.id ? [this.current.id] : [];
      // 获取滤清器备注
      const scheme_id = this.$route.query.scheme_id || this.$route.query.id;
      const params = {
        parts_type: 4,
        vehicle_ids: this.dynamic_vehicle_ids,
        token: this.token,
        scheme_id,
      };
      this.$loading.show("加载中...");
      try {
        // 优先取缓存数据
        let cacheDetail = null;
        const oilFilterCacheString = sessionStorage.getItem("oilFilterCache");
        if (
          oilFilterCacheString &&
          JSON.parse(oilFilterCacheString).key ===
            this.dynamic_vehicle_ids_query
        ) {
          cacheDetail = JSON.parse(oilFilterCacheString).value;
        }
        const res = cacheDetail || (await api.getModelDetail(params));
        if (res.code === 0) {
          // 以key和内部属性为dynamic_vehicle_ids的形式标记菜单和车型，任意时刻仅会存储一种车型的数据
          sessionStorage.setItem(
            "oilFilterCache",
            JSON.stringify({
              key: this.dynamic_vehicle_ids_query,
              value: res,
            })
          );
          if (res.data.parts_list.length > 1) {
            let tempChoices = res.data.parts_list.map((i) => {
              i.text = i.choices[0].value;
              return i;
            });
            this.popupTitle = "车型备注";
            this.popupList = tempChoices;
            this.showPopup = true;
          } else {
            const query_object = {
              scheme_id: this.$route.query.scheme_id,
              menu_type: 4,
              key:
                res.data.parts_list.length === 0
                  ? ""
                  : res.data.parts_list[0].key,
              vehicle_ids: this.dynamic_vehicle_ids,
              internal_from: this.$route.query.internal_from,
            };
            if (this.$route.name === "maintenance-detail") {
              this.dynamic_options = query_object;
              this.setNoteReadyAndSwitchTab();
              return;
            }
            this.$router.push({
              path: "/maintenance-detail",
              query: query_object,
            });
          }
        } else {
          this.$toast.show({
            showTime: 3,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        console.log("获取滤清器备注信息失败", error);
        this.$loading.hide();
      }
      this.$loading.hide();
    },
    // 检查是否有发动机列表/是否有车型备注/都没有直接跳转
    async checkEngineList() {
      await this.fetchValidToken();
      if (!this.token) return;
      const { scheme_id } = this.$route.query;
      const params = {
        ...this.args,
        parts_type: 1,
        token: this.token,
        scheme_id,
      };
      const res = await api.getModelDetail(params);
      if (res.code === 0) {
        console.log(8988988);
        if (res.data.engine_models.length >= 2) {
          let enginesListTemp = res.data.engine_models;
          enginesListTemp.forEach((i) => (i.text = i.engine_model));
          this.multipleEnginesCarsArr = res.data.vehicle_list;
          this.popupList = enginesListTemp;
          this.popupTitle = "发动机";
          this.showPopup = true;
        } else {
          console.log(2333);
          // 单发动机 & 存在粘度选项
          if (res.data.vehicle_list[0].memo_list.length > 0) {
            this.popupList = res.data.vehicle_list[0].memo_list;
            this.popupList.forEach((i) => (i.text = i.memo_val));
            this.popupTitle = "车型备注";
            this.showPopup = true;
          } else {
            const query_object = {
              scheme_id,
              menu_type: 1,
              vehicle_id: res.data.vehicle_list[0].id,
              viscosity_type: 1,
              internal_from: this.$route.query.internal_from,
            };
            console.log(89899878);
            if (this.$route.name === "maintenance-detail") {
              this.dynamic_options = query_object;
              this.setNoteReadyAndSwitchTab();
              return;
            }
            // 单发动机 & 无粘度选项
            this.$router.push({
              path: "/maintenance-detail",
              query: query_object,
            });
          }
        }
      } else {
        this.$toast.show({
          showTime: 3,
          message: res.message,
          style: "error",
        });
      }
    },
    /**
     * 关闭车型备注弹出层
     */
    cancelChoose() {
      this.showPopup = false;
    },
  },
};
